import{URL_DIVIDER as o}from"../../consts/url.js";const n=n=>n.map((o=>encodeURIComponent(o))).join(o);export{n as mapArrayToUrlString};
